DR.teams = DR.teams || {};
DR.teams.struct = DR.teams.struct || {};
DR.teams.select = DR.teams.select || {};
/** @extends {DR._Base} */
DR.teams.struct.TeamResults = function(par){
	/** @private */
	this._t = 1144;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.disqualified)) this.disqualified = Boolean(par.disqualified);
	if(DR._Base.is(par.place)) this.place = (parseInt(par.place)||0);
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
};
DR._Base._types[1144] = DR.teams.struct.TeamResults;
DR.teams.struct.TeamResults[__P] = new DR._Base;
DR.teams.struct.TeamResults[__P][__C] = DR.teams.struct.TeamResults;
/** @type {Boolean} */
DR.teams.struct.TeamResults.prototype.disqualified = null;
/** @type {Number} */
DR.teams.struct.TeamResults.prototype.place = null;
/** @type {Number} */
DR.teams.struct.TeamResults.prototype.points = null;
 
/** @extends {DR._Base} */
DR.teams.struct.Stickers = function(par){
	/** @private */
	this._t = 1146;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.freeStickers)) this.freeStickers = (parseInt(par.freeStickers)||0);
	if(DR._Base.is(par.paidStickers)) this.paidStickers = (parseInt(par.paidStickers)||0);
};
DR._Base._types[1146] = DR.teams.struct.Stickers;
DR.teams.struct.Stickers[__P] = new DR._Base;
DR.teams.struct.Stickers[__P][__C] = DR.teams.struct.Stickers;
/** @type {Number} */
DR.teams.struct.Stickers.prototype.freeStickers = null;
/** @type {Number} */
DR.teams.struct.Stickers.prototype.paidStickers = null;
 
/** @extends {DR._Base} */
DR.teams.struct.TrackingLocation = function(par){
	/** @private */
	this._t = 1009;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.altitude)) this.altitude = (parseFloat(par.altitude)||0);
	if(DR._Base.is(par.bearing)) this.bearing = (parseFloat(par.bearing)||0);
	if(DR._Base.is(par.coordinates)) this.coordinates = DR._Base.cast(par.coordinates);
	if(DR._Base.is(par.ts)) this.ts = (parseInt(par.ts)||0);
};
DR._Base._types[1009] = DR.teams.struct.TrackingLocation;
DR.teams.struct.TrackingLocation[__P] = new DR._Base;
DR.teams.struct.TrackingLocation[__P][__C] = DR.teams.struct.TrackingLocation;
/** @type {Number} */
DR.teams.struct.TrackingLocation.prototype.altitude = null;
/** @type {Number} */
DR.teams.struct.TrackingLocation.prototype.bearing = null;
/** @type {DR.roadgames.struct.Coordinates} */
DR.teams.struct.TrackingLocation.prototype.coordinates = null;
/** @type {Number} */
DR.teams.struct.TrackingLocation.prototype.ts = null;
 
/** @extends {DR._Base} */
DR.teams.struct.Team = function(par){
	/** @private */
	this._t = 1005;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.canAddContent)) this.canAddContent = Boolean(par.canAddContent);
	if(DR._Base.is(par.canChangeImage)) this.canChangeImage = Boolean(par.canChangeImage);
	if(DR._Base.is(par.canChangeTitle)) this.canChangeTitle = Boolean(par.canChangeTitle);
	if(DR._Base.is(par.canChangeUsers)) this.canChangeUsers = Boolean(par.canChangeUsers);
	if(DR._Base.is(par.canEnd)) this.canEnd = Boolean(par.canEnd);
	if(DR._Base.is(par.canExtendTime)) this.canExtendTime = Boolean(par.canExtendTime);
	if(DR._Base.is(par.canInvite)) this.canInvite = Boolean(par.canInvite);
	if(DR._Base.is(par.canJoinAnother)) this.canJoinAnother = Boolean(par.canJoinAnother);
	if(DR._Base.is(par.canLeave)) this.canLeave = Boolean(par.canLeave);
	if(DR._Base.is(par.canPause)) this.canPause = Boolean(par.canPause);
	if(DR._Base.is(par.canStart)) this.canStart = Boolean(par.canStart);
	if(DR._Base.is(par.captain)) this.captain = DR._Base.cast(par.captain);
	if(DR._Base.is(par.code)) this.code = String(par.code||'');
	if(DR._Base.is(par.duration)) this.duration = (parseInt(par.duration)||0);
	if(DR._Base.is(par.durationTimestamp)) this.durationTimestamp = (parseInt(par.durationTimestamp)||0);
	if(DR._Base.is(par.endTime)) this.endTime = (parseInt(par.endTime)||0);
	if(DR._Base.is(par.extensions)) this.extensions = (parseInt(par.extensions)||0);
	if(DR._Base.is(par.hasImage)) this.hasImage = Boolean(par.hasImage);
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.image)) this.image = DR._Base.cast(par.image);
	if(DR._Base.is(par.inviteLink)) this.inviteLink = String(par.inviteLink||'');
	if(DR._Base.is(par.invites)){
		var tmp = [];
		for( var k in par.invites ) tmp.push(String(par.invites [k]||''));
		this.invites = tmp;
	}
	if(DR._Base.is(par.inviteText)) this.inviteText = String(par.inviteText||'');
	if(DR._Base.is(par.isDisqualified)) this.isDisqualified = Boolean(par.isDisqualified);
	if(DR._Base.is(par.isDone)) this.isDone = Boolean(par.isDone);
	if(DR._Base.is(par.isFinished)) this.isFinished = Boolean(par.isFinished);
	if(DR._Base.is(par.isPaid)) this.isPaid = Boolean(par.isPaid);
	if(DR._Base.is(par.isPaused)) this.isPaused = Boolean(par.isPaused);
	if(DR._Base.is(par.isStarted)) this.isStarted = Boolean(par.isStarted);
	if(DR._Base.is(par.isTestTeam)) this.isTestTeam = Boolean(par.isTestTeam);
	if(DR._Base.is(par.maxPlayers)) this.maxPlayers = (parseInt(par.maxPlayers)||0);
	if(DR._Base.is(par.remainingTime)) this.remainingTime = (parseInt(par.remainingTime)||0);
	if(DR._Base.is(par.results)) this.results = DR._Base.cast(par.results);
	if(DR._Base.is(par.sequence)) this.sequence = (parseInt(par.sequence)||0);
	if(DR._Base.is(par.startTime)) this.startTime = (parseInt(par.startTime)||0);
	if(DR._Base.is(par.stickers)) this.stickers = DR._Base.cast(par.stickers);
	if(DR._Base.is(par.title)) this.title = String(par.title||'');
	if(DR._Base.is(par.users)){
		var tmp = [];
		for( var k in par.users ) tmp.push(DR._Base.cast(par.users [k]));
		this.users = tmp;
	}
};
DR._Base._types[1005] = DR.teams.struct.Team;
DR.teams.struct.Team[__P] = new DR._Base;
DR.teams.struct.Team[__P][__C] = DR.teams.struct.Team;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.canAddContent = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.canChangeImage = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.canChangeTitle = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.canChangeUsers = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.canEnd = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.canExtendTime = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.canInvite = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.canJoinAnother = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.canLeave = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.canPause = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.canStart = null;
/** @type {DR.users.struct.User} */
DR.teams.struct.Team.prototype.captain = null;
/** @type {String|null} */
DR.teams.struct.Team.prototype.code = null;
/** @type {Number} */
DR.teams.struct.Team.prototype.duration = null;
/** @type {Number} */
DR.teams.struct.Team.prototype.durationTimestamp = null;
/** @type {Number|null} */
DR.teams.struct.Team.prototype.endTime = null;
/** @type {Number} */
DR.teams.struct.Team.prototype.extensions = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.hasImage = null;
/** @type {Number} */
DR.teams.struct.Team.prototype.id = null;
/** @type {DR.roadgames.struct.Image} */
DR.teams.struct.Team.prototype.image = null;
/** @type {String} */
DR.teams.struct.Team.prototype.inviteLink = null;
/** @type {Array.<String>} */
DR.teams.struct.Team.prototype.invites = null;
/** @type {String} */
DR.teams.struct.Team.prototype.inviteText = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.isDisqualified = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.isDone = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.isFinished = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.isPaid = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.isPaused = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.isStarted = null;
/** @type {Boolean} */
DR.teams.struct.Team.prototype.isTestTeam = null;
/** @type {Number} */
DR.teams.struct.Team.prototype.maxPlayers = null;
/** @type {Number|null} */
DR.teams.struct.Team.prototype.remainingTime = null;
/** @type {DR.teams.struct.TeamResults} */
DR.teams.struct.Team.prototype.results = null;
/** @type {Number} */
DR.teams.struct.Team.prototype.sequence = null;
/** @type {Number|null} */
DR.teams.struct.Team.prototype.startTime = null;
/** @type {DR.teams.struct.Stickers} */
DR.teams.struct.Team.prototype.stickers = null;
/** @type {String} */
DR.teams.struct.Team.prototype.title = null;
/** @type {Array.<DR.users.struct.User>} */
DR.teams.struct.Team.prototype.users = null;
 
/** @extends {DR._Select} */
DR.teams.select.Team = function(){
	this._fields = {};
};
DR.teams.select.Team[__CL] = "Teams__Team";
DR.teams.select.Team[__P] = new DR._Select;
DR.teams.select.Team[__P][__C] = DR.teams.select.Team;
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.canAddContent = function(v){ this._fields.canAddContent = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.canChangeImage = function(v){ this._fields.canChangeImage = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.canChangeTitle = function(v){ this._fields.canChangeTitle = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.canChangeUsers = function(v){ this._fields.canChangeUsers = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.canEnd = function(v){ this._fields.canEnd = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.canExtendTime = function(v){ this._fields.canExtendTime = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.canInvite = function(v){ this._fields.canInvite = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.canJoinAnother = function(v){ this._fields.canJoinAnother = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.canLeave = function(v){ this._fields.canLeave = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.canPause = function(v){ this._fields.canPause = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.canStart = function(v){ this._fields.canStart = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.captain = function(v){ this._fields.captain = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.code = function(v){ this._fields.code = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.duration = function(v){ this._fields.duration = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.durationTimestamp = function(v){ this._fields.durationTimestamp = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.endTime = function(v){ this._fields.endTime = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.extensions = function(v){ this._fields.extensions = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.hasImage = function(v){ this._fields.hasImage = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.id = function(v){ this._fields.id = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.image = function(v){ this._fields.image = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.inviteLink = function(v){ this._fields.inviteLink = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.invites = function(v){ this._fields.invites = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.inviteText = function(v){ this._fields.inviteText = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.isDisqualified = function(v){ this._fields.isDisqualified = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.isDone = function(v){ this._fields.isDone = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.isFinished = function(v){ this._fields.isFinished = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.isPaid = function(v){ this._fields.isPaid = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.isPaused = function(v){ this._fields.isPaused = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.isStarted = function(v){ this._fields.isStarted = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.isTestTeam = function(v){ this._fields.isTestTeam = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.maxPlayers = function(v){ this._fields.maxPlayers = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.remainingTime = function(v){ this._fields.remainingTime = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.results = function(v){ this._fields.results = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.sequence = function(v){ this._fields.sequence = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.startTime = function(v){ this._fields.startTime = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.stickers = function(v){ this._fields.stickers = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.title = function(v){ this._fields.title = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.teams.select.Team} */
DR.teams.select.Team.prototype.users = function(v){ this._fields.users = !DR._Base.is(v) || !!v; return this; };
 
/** @extends {DR._Base} */
DR.teams.struct.TrackingInfo = function(par){
	/** @private */
	this._t = 1010;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.isTracking)) this.isTracking = Boolean(par.isTracking);
	if(DR._Base.is(par.lastLocation)) this.lastLocation = DR._Base.cast(par.lastLocation);
	if(DR._Base.is(par.user)) this.user = DR._Base.cast(par.user);
};
DR._Base._types[1010] = DR.teams.struct.TrackingInfo;
DR.teams.struct.TrackingInfo[__P] = new DR._Base;
DR.teams.struct.TrackingInfo[__P][__C] = DR.teams.struct.TrackingInfo;
/** @type {Boolean} */
DR.teams.struct.TrackingInfo.prototype.isTracking = null;
/** @type {DR.teams.struct.TrackingLocation|null} */
DR.teams.struct.TrackingInfo.prototype.lastLocation = null;
/** @type {DR.users.struct.User|null} */
DR.teams.struct.TrackingInfo.prototype.user = null;
 
/** @extends {DR._Base} */
DR.teams.struct.ProcessInviteRe = function(par){
	/** @private */
	this._t = 1192;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.event)) this.event = DR._Base.cast(par.event);
	if(DR._Base.is(par.needConfirmation)) this.needConfirmation = Boolean(par.needConfirmation);
	if(DR._Base.is(par.team)) this.team = DR._Base.cast(par.team);
};
DR._Base._types[1192] = DR.teams.struct.ProcessInviteRe;
DR.teams.struct.ProcessInviteRe[__P] = new DR._Base;
DR.teams.struct.ProcessInviteRe[__P][__C] = DR.teams.struct.ProcessInviteRe;
/** @type {DR.events.struct.Event} */
DR.teams.struct.ProcessInviteRe.prototype.event = null;
/** @type {Boolean|null} */
DR.teams.struct.ProcessInviteRe.prototype.needConfirmation = null;
/** @type {DR.teams.struct.Team} */
DR.teams.struct.ProcessInviteRe.prototype.team = null;
 
/** @extends {DR._Base} */
DR.teams.struct.SendInvitesRe = function(par){
	/** @private */
	this._t = 1189;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.errors)){
		var tmp = {};
		for( var k in par.errors ) tmp[k] = String(par.errors [k]||'');
		this.errors = tmp;
	}
	if(DR._Base.is(par.ok)) this.ok = Boolean(par.ok);
};
DR._Base._types[1189] = DR.teams.struct.SendInvitesRe;
DR.teams.struct.SendInvitesRe[__P] = new DR._Base;
DR.teams.struct.SendInvitesRe[__P][__C] = DR.teams.struct.SendInvitesRe;
/** @type {Object.<String,String>} */
DR.teams.struct.SendInvitesRe.prototype.errors = null;
/** @type {Boolean} */
DR.teams.struct.SendInvitesRe.prototype.ok = null;
 
/** @extends {DR._Method} */
DR.teams.ActivateTracking = function(par){
	this.select = [];
	/** @private */
	this._t = 1011;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1011] = DR.teams.ActivateTracking;
DR.teams.ActivateTracking[__CL] = "Teams__ActivateTracking";
DR.teams.ActivateTracking[__P] = new DR._Method;
DR.teams.ActivateTracking[__P][__C] = DR.teams.ActivateTracking;
/** @type {DR.teams.struct.TrackingInfo} */
DR.teams.ActivateTracking.prototype.re = null;
 
/** @extends {DR._Method} */
DR.teams.ChangeTitle = function(par){
	this.select = [];
	/** @private */
	this._t = 1188;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1188] = DR.teams.ChangeTitle;
DR.teams.ChangeTitle[__CL] = "Teams__ChangeTitle";
DR.teams.ChangeTitle[__P] = new DR._Method;
DR.teams.ChangeTitle[__P][__C] = DR.teams.ChangeTitle;
/** @type {String} */
DR.teams.ChangeTitle.prototype.title = null;
/** @type {DR.teams.struct.Team} */
DR.teams.ChangeTitle.prototype.re = null;
 
/** @extends {DR._Method} */
DR.teams.DeactivateTracking = function(par){
	this.select = [];
	/** @private */
	this._t = 1012;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1012] = DR.teams.DeactivateTracking;
DR.teams.DeactivateTracking[__CL] = "Teams__DeactivateTracking";
DR.teams.DeactivateTracking[__P] = new DR._Method;
DR.teams.DeactivateTracking[__P][__C] = DR.teams.DeactivateTracking;
/** @type {DR.teams.struct.TrackingInfo} */
DR.teams.DeactivateTracking.prototype.re = null;
 
/** @extends {DR._Method} */
DR.teams.Delete = function(par){
	this.select = [];
	/** @private */
	this._t = 1263;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1263] = DR.teams.Delete;
DR.teams.Delete[__CL] = "Teams__Delete";
DR.teams.Delete[__P] = new DR._Method;
DR.teams.Delete[__P][__C] = DR.teams.Delete;
/** @type {DR.roadgames.struct.Status} */
DR.teams.Delete.prototype.re = null;
 
/** @extends {DR._Method} */
DR.teams.GetTeam = function(par){
	this.select = [];
	/** @private */
	this._t = 1207;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1207] = DR.teams.GetTeam;
DR.teams.GetTeam[__CL] = "Teams__GetTeam";
DR.teams.GetTeam[__P] = new DR._Method;
DR.teams.GetTeam[__P][__C] = DR.teams.GetTeam;
/** @type {Number|null} */
DR.teams.GetTeam.prototype.eventId = null;
/** @type {DR.teams.struct.Team} */
DR.teams.GetTeam.prototype.re = null;
 
/** @extends {DR._Method} */
DR.teams.GetTrackingInfo = function(par){
	this.select = [];
	/** @private */
	this._t = 1013;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1013] = DR.teams.GetTrackingInfo;
DR.teams.GetTrackingInfo[__CL] = "Teams__GetTrackingInfo";
DR.teams.GetTrackingInfo[__P] = new DR._Method;
DR.teams.GetTrackingInfo[__P][__C] = DR.teams.GetTrackingInfo;
/** @type {DR.teams.struct.TrackingInfo} */
DR.teams.GetTrackingInfo.prototype.re = null;
 
/** @extends {DR._Method} */
DR.teams.Leave = function(par){
	this.select = [];
	/** @private */
	this._t = 1221;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1221] = DR.teams.Leave;
DR.teams.Leave[__CL] = "Teams__Leave";
DR.teams.Leave[__P] = new DR._Method;
DR.teams.Leave[__P][__C] = DR.teams.Leave;
/** @type {DR.roadgames.struct.Status} */
DR.teams.Leave.prototype.re = null;
 
/** @extends {DR._Method} */
DR.teams.ProcessInvite = function(par){
	this.select = [];
	/** @private */
	this._t = 1193;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1193] = DR.teams.ProcessInvite;
DR.teams.ProcessInvite[__CL] = "Teams__ProcessInvite";
DR.teams.ProcessInvite[__P] = new DR._Method;
DR.teams.ProcessInvite[__P][__C] = DR.teams.ProcessInvite;
/** @type {Boolean|null} */
DR.teams.ProcessInvite.prototype.forceJoin = null;
/** @type {String} */
DR.teams.ProcessInvite.prototype.key = null;
/** @type {DR.teams.struct.ProcessInviteRe} */
DR.teams.ProcessInvite.prototype.re = null;
 
/** @extends {DR._Method} */
DR.teams.RemoveInvite = function(par){
	this.select = [];
	/** @private */
	this._t = 1191;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1191] = DR.teams.RemoveInvite;
DR.teams.RemoveInvite[__CL] = "Teams__RemoveInvite";
DR.teams.RemoveInvite[__P] = new DR._Method;
DR.teams.RemoveInvite[__P][__C] = DR.teams.RemoveInvite;
/** @type {String} */
DR.teams.RemoveInvite.prototype.email = null;
/** @type {DR.roadgames.struct.Status} */
DR.teams.RemoveInvite.prototype.re = null;
 
/** @extends {DR._Method} */
DR.teams.RemoveUser = function(par){
	this.select = [];
	/** @private */
	this._t = 1194;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1194] = DR.teams.RemoveUser;
DR.teams.RemoveUser[__CL] = "Teams__RemoveUser";
DR.teams.RemoveUser[__P] = new DR._Method;
DR.teams.RemoveUser[__P][__C] = DR.teams.RemoveUser;
/** @type {Number} */
DR.teams.RemoveUser.prototype.userId = null;
/** @type {DR.teams.struct.Team} */
DR.teams.RemoveUser.prototype.re = null;
 
/** @extends {DR._Method} */
DR.teams.SendInvites = function(par){
	this.select = [];
	this.emails = [];
	/** @private */
	this._t = 1190;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1190] = DR.teams.SendInvites;
DR.teams.SendInvites[__CL] = "Teams__SendInvites";
DR.teams.SendInvites[__P] = new DR._Method;
DR.teams.SendInvites[__P][__C] = DR.teams.SendInvites;
/** @type {Array.<String>} */
DR.teams.SendInvites.prototype.emails = null;
/** @type {DR.teams.struct.SendInvitesRe} */
DR.teams.SendInvites.prototype.re = null;
 
/** @extends {DR._Method} */
DR.teams.SetCaptain = function(par){
	this.select = [];
	/** @private */
	this._t = 1195;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1195] = DR.teams.SetCaptain;
DR.teams.SetCaptain[__CL] = "Teams__SetCaptain";
DR.teams.SetCaptain[__P] = new DR._Method;
DR.teams.SetCaptain[__P][__C] = DR.teams.SetCaptain;
/** @type {Number} */
DR.teams.SetCaptain.prototype.userId = null;
/** @type {DR.teams.struct.Team} */
DR.teams.SetCaptain.prototype.re = null;
 
D.loaded();